/**
 * Beslist wat er moet gebeuren als iemand een kaart loslaat op het bord.
 *
 * Apart van het component omdat hier de drie gevallen zitten waarin er juist
 * NIETS moet gebeuren, en die zijn in een sleeptest bijna niet na te bootsen:
 * losgelaten in dezelfde kolom, losgelaten buiten het bord, en losgelaten op
 * iets wat geen kolom is. Elk van die drie zou anders een statuswissel
 * wegschrijven — inclusief een regel in de statushistorie voor een wissel die
 * niet plaatsvond, en die is achteraf niet te verwijderen.
 *
 * AI-CONTEXT: See docs/features/household-board-view.md
 */

/**
 * @typedef {object} BoardMove
 * @property {string|number} itemId - Het record dat verplaatst is
 * @property {string} from - De status waar het vandaan kwam
 * @property {string} to - De status waar het naartoe ging
 */

/**
 * @param {object} [event] - Het `onDragEnd`-event van dnd-kit
 * @param {Array<string>} [columnKeys] - De statussleutels die als kolom op het bord staan
 * @returns {BoardMove|null} `null` betekent: doe niets
 */
const resolveDrop = (event, columnKeys) => {
    const kolommen = Array.isArray(columnKeys) ? columnKeys : []
    const active = event && event.active
    const over = event && event.over

    if (!active || !over) return null

    // De herkomst reist mee in de kaart zelf. Zonder herkomst is er geen 'van'
    // voor de statushistorie, en dan is het beter niets te schrijven dan een
    // halve regel.
    const from = active.data && active.data.current && active.data.current.status
    if (!from) return null

    // dnd-kit geeft een id terug zoals je hem erin stopte — string of getal.
    const to = String(over.id)

    if (!kolommen.includes(to)) return null
    if (to === from) return null

    return { itemId: active.id, from, to }
}

export default resolveDrop
